var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 476.30000000000007",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 1985,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 259.8V0l225 129.9v86.6L75 129.9v173.2z",
    fill: "#00b0ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225 129.9L450 0v259.8l-150 86.6-75-43.3 150-86.6v-86.6l-150 86.6z",
    fill: "#0081cb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225 303.1v86.6l150 86.6v-86.6z",
    fill: "#00b0ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M375 476.3l225-129.9V173.2l-75 43.3v86.6l-150 86.6zm150-346.4V43.3L600 0v86.6z",
    fill: "#0081cb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialUi);
export default __webpack_public_path__ + "static/media/material-ui.fd510ed8518b192069590b04e2e6348a.svg";
export { ForwardRef as ReactComponent };